import React, { useEffect, useState } from 'react';
import { getStorySettings, login } from '../api/api';

function WorldView() {
  const [worldviews, setWorldviews] = useState([
    { id: 1, name: '赛博朋克', checked: false },
    { id: 2, name: '克苏鲁', checked: false },
    { id: 3, name: '现代都市', checked: false },
    { id: 4, name: '武侠江湖', checked: false },
    { id: 5, name: '游戏', checked: false }
  ]);

  function handleWorldviewClick(worldview) {
    worldview.checked = !worldview.checked;
    setWorldviews([...worldviews]);

    // 获取所有选中的世界观名称
    const selectedWorldviewNames = worldviews
      .filter(s => s.checked)
      .map(s => s.name);

    // 将选中的世界观名称存储到 localStorage
    localStorage.setItem('selectedWorldviewNames', JSON.stringify(selectedWorldviewNames));
  }

  return (
    <div style={{
      backgroundImage: 'url(/images/background.png)', // 使用相对于 public 目录的路径
      backgroundSize: 'cover',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'hidden' // 设置超出隐藏
    }}>
      <img src="/images/title.png" alt="Title" style={{
        position: 'absolute',
        top: '10px',
        left: '30px',
        width: '60px'
      }} />
      <div style={{
        position: 'absolute',
        top: '25px',
        right: '40px',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        世界观选择
      </div>

      <div 
        style={{ 
          position:'fixed',
          top:'80px',
          fontSize: '12px', 
          marginBottom: '10px', 
          fontWeight: 500 
        }}
      >
        请选择在短剧中需要出现的世界观，世界观可以选择多个
      </div>

    <div style={{
      width:'300px',
      display: 'flex',
      flexWrap: 'wrap',
      position: 'fixed',
      alignItems:'center',
      justifyContent:'start',
      marginLeft:'10px',
      left: '50%',
      transform: 'translateX(-50%)',
      top:'0px',
      marginTop: '120px',
    }}>
      {worldviews.map(worldview => (
        <div 
          key={worldview.id}
          style={{
            width: '80px',
            height: '40px',
            backgroundColor: worldview.checked ? '#F65555' : 'white',
            border: '1px solid #ccc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: '15px',
            padding: '20px',
            margin: '10px'
          }}
          onClick={() => handleWorldviewClick(worldview)}
        >
          <span style={{ fontSize: '16px', marginTop: '5px', textAlign: 'center', width: '100%' }}>{worldview.name}</span>
        </div>
      ))}
    </div>
    <button 
          onClick={() => window.location.href = '/genres-select'}
          style={{
            position: 'fixed',
            bottom: '50px',
            padding: '10px 20px',
            fontSize: '16px',
            width: '55%',
            height: '80px',
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
          下一步
    </button>
    </div>
  );
}

export default WorldView;
